import {
  BriefcaseIcon,
  BuildingOffice2Icon,
  BuildingOfficeIcon,
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  CreditCardIcon,
  DocumentCheckIcon,
  DocumentTextIcon,
  HomeIcon,
  LinkIcon,
  MagnifyingGlassIcon,
  StarIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { IconType } from '~/types';
import { paths } from './routes';

/**
 * Single source of truth mapping each HLX route to a Heroicon. Consumed by the
 * HLX sidebar, the dashboard cards and the empty states so all three render the
 * same icon for a given destination and cannot drift apart (MCV-1516).
 *
 * Before this was shared, the sidebar and the dashboard disagreed on two of the
 * four cards — Job Responses was a briefcase in one and an inbox in the other,
 * B2B Responses an office block versus a scale — which is what prompted "match
 * icons on each card to the ones on the left sidebar".
 *
 * Mirrors the vault-side arrangement in ./vaultTopicIcons.
 */
export const HLX_NAV_ICONS: Record<string, IconType> = {
  [paths.hlx.dashboard]: HomeIcon,
  [paths.hlx.calendar]: CalendarDaysIcon,
  [paths.hlx.listings]: ClipboardDocumentListIcon,
  [paths.hlx.msaasListings]: DocumentTextIcon,
  [paths.hlx.jobOpportunities]: BriefcaseIcon,
  [paths.hlx.serviceOpportunities]: BriefcaseIcon,
  [paths.hlx.b2bOpportunities]: BuildingOfficeIcon,
  [paths.hlx.listingSearch]: MagnifyingGlassIcon,
  [paths.hlx.contracts]: DocumentCheckIcon,
  [paths.hlx.search]: UserGroupIcon,
  [paths.hlx.providerAssociations]: LinkIcon,
  [paths.hlx.employerInfo]: BuildingOfficeIcon,
  [paths.hlx.facilities]: BuildingOffice2Icon,
  [paths.hlx.billing]: CreditCardIcon,
  [paths.hlx.team]: UserGroupIcon,
  [paths.hlx.myServices]: StarIcon,
};

/**
 * Resolve an HLX destination's icon. Returns undefined for unknown paths so
 * callers can fall back to a default.
 */
export const getHlxNavIcon = (path?: string): IconType | undefined => {
  if (!path) return undefined;
  return HLX_NAV_ICONS[path];
};
